import React from 'react';
import Logo from '../Logo';

const Hero = () => {
    return (
        <div className="self-stretch px-8 pb-0 pt-8 relative overflow-hidden" style={{background: 'linear-gradient(135deg, #055efd 0%, #0449d4 100%)'}}>
            <div className="absolute left-24 bottom-0 lg:top-0 opacity-40 w-[462px] h-[462px] lg:w-[600px] lg:h-[600px] z-0">
                <Logo width="100%" height="100%" logoFill="#6b21a8" mobile={true} />
            </div>
            <div className="w-[494.84px] h-[497.50px] absolute right-32 -bottom-[26rem] rotate-[8.60deg] opacity-30 rounded-full hidden lg:block" style={{backgroundColor: '#310da6'}}></div>

            <div className="max-w-7xl mx-auto relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-end">
                    <div className="flex flex-col gap-6 justify-center pb-24 order-1 lg:order-2">
                        <div className="flex flex-col gap-4">
                            <h1 className="text-white font-bold leading-tight heading-1" style={{color: 'white'}}>
                                Innovation in Motion
                            </h1>
                            <p className="text-white font-medium leading-relaxed body-text" style={{color: 'white', fontSize: '1.125rem'}}>
                                We're building the future of AI-powered business solutions. 
                                Our cutting-edge technology transforms how companies interact with their customers.
                            </p>
                        </div>
                        
                        {/* Under Construction Notice */}
                        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                            <div className="flex items-center mb-3">
                                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mr-3"></div>
                                <h3 className="text-xl font-semibold text-white mb-3 heading-3" style={{color: 'white'}}>Website Under Construction</h3>
                            </div>
                            <p className="text-gray-200 body-text" style={{color: '#e5e7eb'}}>
                                We're putting the finishing touches on our new website. 
                                Check back soon for exciting updates!
                            </p>
                        </div>

                        <div className="flex flex-wrap gap-4">
                            <a href="mailto:info@rocketlabventures.com">
                                <div className="btn-primary">
                                    <div className="font-bold">Get in Touch</div>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div className="relative flex justify-center lg:justify-start items-end order-2 lg:order-1 z-20">
                        <div className="w-full max-w-lg h-96 bg-gradient-to-br from-purple-400/20 to-blue-400/20 rounded-3xl flex items-center justify-center">
                            <div className="text-center text-white">
                                <div className="w-24 h-24 mx-auto mb-4 bg-white/10 rounded-full flex items-center justify-center">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold mb-2 heading-3" style={{color: 'white'}}>AI Innovation</h3>
                                <p className="text-gray-200 body-text" style={{color: '#e5e7eb'}}>Transforming Business</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;